import React from 'react';

type Props = {
  size: number;
  style?: { [key: string]: string | number };
};

export const AppQrCode = (props: Readonly<Props>) => {
  const { size, style } = props;
  return (
    <img
      alt="App Download QR Code"
      height={`${size}px`}
      src="/cep/assets/img/qrCodes/x4c_login_page.png"
      style={{
        borderRadius: '6px',
        boxShadow: '0px 2px 7px 0px #00000040',
        padding: '4px',
        ...style,
      }}
      width={`${size}px`}
    />
  );
};
